import React, { useEffect, useRef } from "react";
import { useSector } from "./SectorContext";
import { useNavigate } from "react-router-dom";

function AwardCarousel() {
  const { awardData = [], activeSector } = useSector();
  const carouselRef = useRef(null);
  const navigate = useNavigate()

  // Return to the first award whenever the sector changes.
  useEffect(() => {
    if (carouselRef.current) {
      carouselRef.current.scrollTo({
        left: 0,
        behavior: "smooth",
      });
    }
  }, [activeSector]);

  const moveCarousel = (direction) => {
    const carousel = carouselRef.current;

    if (!carousel) return;

    const firstCard = carousel.querySelector(".award-carousel-card");

    if (!firstCard) return;

    const carouselStyles = window.getComputedStyle(carousel);
    const carouselGap = parseFloat(carouselStyles.columnGap) || 0;
    const scrollDistance = firstCard.offsetWidth + carouselGap;

    carousel.scrollBy({
      left: direction * scrollDistance,
      behavior: "smooth",
    });
  };

  // Do not show the section when the current sector has no awards.
  if (!awardData.length) return null;

  return (
    <section className="award-carousel-section">
      <div className="award-section-header">
        <div>
          <p className="award-carousel-section-label">A FEW WINS</p>
          {/* <h2 className="award-carousel-section-title">Trophy Case</h2> */}
        </div>

        {awardData.length > 1 && (
          <div className="award-carousel-controls">
            <button
              type="button"
              className="award-carousel-button"
              onClick={() => moveCarousel(-1)}
              aria-label="View previous award"
            >
              <span aria-hidden="true">←</span>
            </button>

            <button
              type="button"
              className="award-carousel-button"
              onClick={() => moveCarousel(1)}
              aria-label="View next award"
            >
              <span aria-hidden="true">→</span>
            </button>
          </div>
        )}
      </div>

      <div
        className="award-carousel"
        ref={carouselRef}
        aria-label="Awards carousel"
      >
        {awardData.map((award, index) => {
          const awardKey = `${award.awardname}-${award.year}-${index}`;

          const cardContent = (
            <>
              <img
                className="award-image"
                src={award.badgeimage}
                alt={`${award.awardname} badge`}
              />

              <div className="award-title">{award.awardname}</div>

              <div className="award-category">{award.category}</div>

              <div className="award-meta">
                {/* <div>
                  <strong>Client</strong>
                  <span>{award.client}</span>
                </div> */}
                <div>
                  <strong>Campaign: </strong>
                  <span>{award.campaign}</span>
                </div>

                {/* <div>
                  <strong>Year</strong>
                  <span>{award.year}</span>
                </div>

                <div>
                  <strong>Role</strong>
                  <span>{award.role}</span>
                </div> */}
              </div>
            </>
          );

          return (
            <article className="award-carousel-card award-card" key={awardKey}>
              {award.certlink ? (
                <a
                  href={award.certlink}
                  className="award-image-link"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={`View and verify ${award.awardname}`}
                >
                  {cardContent}
                </a>
              ) : (
                <div className="award-image-link">{cardContent}</div>
              )}
            </article>
          );
        })}
      </div>
     <button
  type="button"
  className="award-carousel-cta"
  onClick={() => navigate("/about#awards")}
>
  See more award info
  <span aria-hidden="true">→</span>
</button>
    </section>
  );
}

export default AwardCarousel;
